import { Injectable } from '@angular/core';
@Injectable()
export class RouteConstants {
  public static readonly SIGNIN: string = 'login';
  public static readonly RESTRICTED_ACCESS = 'restricted'
  public static readonly ACCOUNT_CREATED = "account/success"
  public static readonly USER_EXIST = "account/exist"
  public static readonly INSTALLER_DASHBOARD: string = 'installer';
  public static readonly ADMIN_DASHBOARD: string = 'admin';
  public static readonly ADMIN_ROUTES: string[] = [
    RouteConstants.ADMIN_DASHBOARD,
  ];
  public static readonly INSTALLER_ROUTES: string[] = [
    RouteConstants.INSTALLER_DASHBOARD,
  ];
  public static readonly ADMIN_INSTALLER_ROUTES: string = RouteConstants.ADMIN_DASHBOARD + "/view/installer/dashboard"
  public static readonly ADMIN_CUSTOMER_ROUTES: string = RouteConstants.ADMIN_DASHBOARD + "/view/installer/dashboard/customer"
  public static readonly DEVICE_CUSTOMER_ROUTES: string = RouteConstants.ADMIN_DASHBOARD + "/view/installer/dashboard/device"
}
